import { createTPluginFactory } from '../../plate';
import { KEY_SINGLE_CHILD } from '../../pluginKeys';
import { SingleChildPlugin } from './types';
import { withSingleChild } from './withSingleChild';

export const createSingleChildPlugin = createTPluginFactory<SingleChildPlugin>({
  key: KEY_SINGLE_CHILD,
  withOverrides: withSingleChild,
});
